import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import { themedFonts, useCurrentTheme } from '@gitbook/react-uikit';

import { ensureStackElements } from './ContentKitStack';
import { ContentKitTextStyleContext } from './ContentKitText';
import type { ContentKitElementProps } from './types';

/**
 * Hint wrapper for inline elements.
 */
export function ContentKitHint(
    props: ContentKitElementProps<api.ContentKitHint>
): React.ReactElement {
    const { element, renderElements } = props;
    const [, font] = useCurrentTheme(themedFonts);

    return (
        <div>
            <ContentKitTextStyleContext.Provider value={[font.Label, font.textMid]}>
                {renderElements('inline', ensureStackElements('hstack', element.children, 'start'))}
            </ContentKitTextStyleContext.Provider>
        </div>
    );
}
